import { useMemo } from 'react';

function useCurrentManagerRecord({
  fallbackName = 'Current manager',
  fallbackRoleTitle = '',
  sourceRecord = null,
  user
}) {
  return useMemo(() => {
    if (!user?.managerId) {
      return null;
    }

    return {
      id: user.managerId,
      name: user.managerName || sourceRecord?.name || fallbackName,
      roleTitle: user.roleTitle || sourceRecord?.roleTitle || sourceRecord?.role || fallbackRoleTitle,
      locationCode: user.locationCode
    };
  }, [fallbackName, fallbackRoleTitle, sourceRecord, user]);
}

export default useCurrentManagerRecord;
